import * as React from "react";
const SvgFiRrLocationArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-location-arrow_svg__a)">
      <path
        fill="#062147"
        d="M22.858 1.142C21.77.052 20.195-.288 18.722.268L2.328 7.062C.392 7.79-.206 9.598.061 11.064c.268 1.468 1.464 2.948 3.534 2.948h6.38v6.394c0 2.069 1.48 3.266 2.946 3.532q.33.06.674.06c1.31 0 2.708-.673 3.32-2.294l6.83-16.457a3.83 3.83 0 0 0-.887-4.105m-.974 3.369-6.83 16.457c-.346.915-1.145 1.118-1.774 1.004-.632-.115-1.307-.587-1.307-1.565v-7.394a1 1 0 0 0-1-1H3.595c-.979 0-1.45-.675-1.566-1.307-.114-.631.09-1.43 1.035-1.785l16.394-6.794q.34-.127.68-.127c.481 0 .942.19 1.307.556.535.535.694 1.278.44 1.955"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-location-arrow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLocationArrow;
